import { motion } from "framer-motion";
import { lineReveal } from "@/lib/motion";

export const PageHero = ({ kicker, title, subtitle, image }) => (
  <section className="relative overflow-hidden pt-[72px]" data-testid="page-hero">
    <div className="radial-glow absolute inset-0" />
    <div className="hatch-bg absolute inset-0 opacity-40" />
    {image && (
      <>
        <div className="absolute inset-0">
          <img src={image} alt="" className="h-full w-full object-cover opacity-[0.14]" />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#0E0E10]/60 via-[#0E0E10]/80 to-[#0E0E10]" />
      </>
    )}
    <div className="container-px relative py-20 lg:py-28">
      <div className="max-w-4xl">
        {kicker && (
          <div className="kicker mb-5 flex items-center gap-2">
            <span className="h-px w-8 bg-orange-400/60" /> {kicker}
          </div>
        )}
        <div className="reveal-mask pb-2">
          <motion.h1
            variants={lineReveal}
            initial="hidden"
            animate="show"
            className="font-head text-4xl font-extrabold leading-[1.12] tracking-tight text-white sm:text-5xl lg:text-6xl"
          >
            {title}
          </motion.h1>
        </div>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.7 }}
            className="mt-6 max-w-2xl text-lg leading-relaxed text-zinc-400"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </div>
  </section>
);
